// @flow
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { hot } from 'react-hot-loader'
import './styles.scss'

import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Footer } from '@ta-interaktiv/react-footer'
import { Waypoint } from 'react-waypoint'
import Quiz from '../quiz'

type Props = {
  articleId: string
}

const ADDITIONAL_SHARES = 248

class AppComponent extends Component<Props> {
  static defaultProps = {
    articleId: '19613986'
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          articleID={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
        />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Haben Sie das Zeug zum Geldwäscherei-Profi?
            </h1>

            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                Das neue Datenleck «Troika-Laundromat» enthüllt, wie Schweizer
                Banken Millionen aus dubiosen Quellen annahmen. Hätten Sie die
                Geldflüsse gestoppt? Machen Sie den grossen Geldwäscherei-Test –
                mit echten Fällen aus dem Leck.
              </div>
            </h2>
            <p className='ta author'>
              <strong>
                Von Christian Brönnimann und Patrick Vögeli (Interaktiv-Team)
              </strong>
            </p>
          </div>

          <div className='animation-container'>
            <iframe
              src='https://interaktiv.tagesanzeiger.ch/2019/geldwaescherei-quiz/header/geldwaesche.html'
              frameBorder='0'
              allowtransparency='true'
              allowFullScreen='allowfullscreen'
              webkitallowfullscreen='webkitallowfullscreen'
              mozallowfullscreen='mozallowfullscreen'
              oallowfullscreen='oallowfullscreen'
              msallowfullscreen='msallowfullscreen'
              width='100%'
              scrolling='no'
              style={{ overflow: 'hidden' }}
              className='mobile hidden'
            />

            <iframe
              src='https://interaktiv.tagesanzeiger.ch/2019/geldwaescherei-quiz/header/geldwaesche_2_mobile.html'
              frameBorder='0'
              allowtransparency='true'
              allowFullScreen='allowfullscreen'
              webkitallowfullscreen='webkitallowfullscreen'
              mozallowfullscreen='mozallowfullscreen'
              oallowfullscreen='oallowfullscreen'
              msallowfullscreen='msallowfullscreen'
              width='100%'
              scrolling='no'
              style={{ overflow: 'hidden' }}
              className='mobile only'
            />
          </div>
        </header>

        <div className='ui text container'>
          <p className='firstParagraph'>
            Sie sind die Chefin oder der Chef der internen Aufsicht einer
            Geldwäscherei-Kontrolle. Täglich kommen Zahlungseingänge auf Ihr
            Pult, bei denen Sie nicht sicher sind, ob hier jemand versucht, Geld
            in Ihrer Bank zu waschen.
          </p>
          <p>
            Geldwäscher parkieren die Profite aus einem Verbrechen gerne in der
            Schweiz. Gegenüber der hiesigen Bank tun sie so, als handle es sich
            um Einkünfte aus legalen Geschäften. Dabei legen sie beispielsweise
            Verkaufsverträge, Rechnungen oder dergleichen vor, die beweisen
            sollen, dass alles mit rechten Dingen zugeht. Aber genügen diese
            Dokumente?
          </p>
          <p>
            Wir zeigen Ihnen hier eine Reihe echter Fälle mit echten Dokumenten
            aus dem neuen Laundromat-Datenleck vor. Sie müssen jeweils
            entscheiden, ob Sie das Geld in Ihre Bank lassen. Senderin des
            Geldes ist in jedem der Fälle die litauische Bank Ukio, die im
            Zentrum eines riesigen Schemas stand, mit dem Milliarden aus
            dubiosen russischen Quellen auf westliche Banken geschleust wurden (
            <a href='https://www.tagesanzeiger.ch/22311400' target='_blank'>
              <i className='icon external alternate' />
              So funktioniert der russische Geld-Waschsalon
            </a>
            ). Nach jedem Fall erklärt der Experte für Geldwäscherei-Bekämpfung,
            Daniel Thelesklaf, ob Sie richtig oder falsch gehandelt haben. Und
            wir verraten Ihnen, was die betreffende Schweizer Bank damals
            tatsächlich mit dem Geld gemacht hat.
          </p>
          <p>Los gehts!</p>
        </div>

        <main className='ui vertical fitted segment'>
          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
          </div>
          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Fall 1</h2>
            <span className='pretext'>Seltsames Maschinengeschäft</span>
          </div>

          <div className='ui text container'>
            <Quiz
              qId='quiz-0'
              articleId='19613986'
              solution='nein'
              imageTitle='bixman_1'
              titleDocument='Originalbelege'
              descriptionDocument='(Klicken zum Vergrössern)'
              filenameDocument='bixman_1.png'
              question='Nehmen Sie das Geld an?'
              textOneTitle='Woher kommt das Geld?'
              textOne='Eine Briefkastenfirma aus Panama hat bei Ihrer Bank ein Konto. Darauf
              treffen 3,1 Millionen Euro ein, gestückelt in fünf Tranchen. Bezahlt wird die
              Summe von einer weiteren Briefkastenfirma, dieses Mal in Belize, das ist ein
              kleines Land in Mittelamerika. Das Konto dieser Firma liegt aber bei der Bank
              Ukio in Litauen. Alles klar?'
              textTwoTitle='Die Begründung der Zahlungen'
              textTwo='Als Beweis, dass die Zahlungen auf einem legalen Geschäft beruhen,
              legt Ihr Kunde zwei identische Kaufverträge vor. Darin steht, dass Maschinen
              im Gesamtwert von drei Millionen Euro verkauft wurden.'
              textThreeTitle='Das Problem'
              textThree={
                <>
                  In den beiden Verträgen ist die Panama-Briefkastenfirma mit
                  dem Konto bei Ihrer Bank als{' '}
                  <span style={{ borderBottom: 'solid 2px' }}>Käuferin</span>{' '}
                  genannt. Ihr Kunde sollte also die 3,1 Millionen eigentlich
                  selber zahlen, nicht erhalten.
                </>
              }
              expertentext='Welcher seriöse Kaufmann würde aufgrund einer solchen Rechnung Millionen ausgeben?
              Dies ergibt keinen wirtschaftlichen Sinn. Die Dokumente sind mit hoher Wahrscheinlichkeit Scheinrechnungen.
              Und die Gelder kommen auch noch aus Litauen, ein Land mit erheblichen Problemen bei der Bankenaufsicht.
              Ich würde die Gelder nicht auf das Konto des Kunden gutschreiben, sondern zurücksenden, auch wenn die
              Beträge nicht ungewöhnlich hoch sind.'
              realCaseTitle='Was tatsächlich geschah'
              realCaseText='Trotz des fehlerhaften Vertrages traf das Geld der Belize-Firma unbehelligt bei der VP Bank in Zürich ein. Vier Tranchen im April 2010, eine Tranche im September 2010.'
            />
          </div>

          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
          </div>
          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Fall 2</h2>
            <span className='pretext'>Klimaanlagen mit Preisschwankungen</span>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-1'
              articleId='19613986'
              solution='nein'
              imageTitle='castle_2'
              titleDocument='Originalbelege'
              descriptionDocument='(Klicken zum Vergrössern)'
              filenameDocument='castle_2.png'
              documentIsWide={true}
              question='Nehmen Sie das Geld an?'
              textOneTitle='Woher kommt das Geld?'
              textOne='Diesmal sollen fünf Millionen Dollar in Ihre Bank kommen.
              Wieder kommt das Geld von einer Briefkastenfirma aus Belize mit einem
              Konto bei der litauischen Ukio-Bank.'
              textTwoTitle='Die Begründung der Zahlungen'
              textTwo='In diesem Fall kaufte die Belize-Firma angeblich Klimaanlagen
              von Ihrem Kunden. Er will das belegen mit einer ganzen Serie von Rechnungen,
              die er ausgestellt hat.'
              textThreeTitle='Das Problem'
              textThree='Viele der Rechnungen sind praktisch identisch. Bei denselben
              Klimaanlagen steht der gleiche Preis, aber hinter dem Preis steht einmal US-Dollar,
              dann wieder Euro. Die Preise für dieselben Maschinen schwanken also um über ein
              Viertel – innerhalb weniger Tage. Zudem ist die Gesamtsumme auf mehreren
              Rechnungen falsch.'
              expertentext='Auch hier liegen eine ganze Reihe von Risikofaktoren vor, und es dürfte
              sich mit hoher Wahrscheinlichkeit um Scheinrechnungen handeln. Ich hätte diese Zahlungen
              nicht angenommen. Ein seriöser Kaufmann verwechselt nicht einfach Währungen. Ich würde
              auch künftige Zahlungen aufgrund solcher Dokumente ablehnen.'
              realCaseTitle='Was tatsächlich geschah'
              realCaseText='Die rund fünf Millionen Dollar trafen in zwölf Tranchen unbehelligt bei der UBS ein: Zwischen August 2009 und Dezember 2009.'
            />
          </div>

          <p className='spaced'>&nbsp;</p>
          <div className='ui text container'>
            <h5 className='continueTitle'>Die Fortsetzung des Falls:</h5>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-2'
              articleId='19613986'
              solution='nein'
              question='Lassen Sie den Geldfluss zu?'
              textOne='Zwei Jahre später fliesst vom selben Konto bei Ihrer Bank Geld
              zurück zu den vermeintlichen Klimaanlagen-Käufern aus Belize. Nun wollen
              diese gemäss neuen Rechnungen ihrerseits Ihrem Kunden elektronische Geräte
              verkauft haben. Insgesamt fliessen knapp zwei Millionen Dollar wieder ab.'
              expertentext='Ich würde in diesem Fall sogar den Abfluss des Geldes aus der Bank
              verhindern. Hier kommt neben der Scheinrechnung und den Unstimmigkeiten hinsichtlich
              der Währung ein weiterer Anhaltspunkt für Geldwäscherei dazu: Die Umkehrung der Rollen
              – Käufer und Verkäufer – ohne ersichtlichen Grund. Ohnehin stellt sich die Frage, welche
              Rolle eine Gesellschaft in Mittelamerika bei solchen Handelsgeschäften haben soll.'
              realCaseTitle='Was tatsächlich geschah'
              realCaseText='Diese zwei Millionen Dollar flossen im Dezember 2011 von der UBS zur Firma in Belize.'
            />
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />

          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
          </div>

          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Fall 3</h2>
            <span className='pretext'>Baumaterialien für Litauen</span>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-3'
              articleId='19613986'
              solution='ja'
              filenameDocument='geldwaescherei_document_2.png'
              question='Nehmen Sie das Geld an?'
              textOneTitle='Woher kommt das Geld?'
              textOne='Sie sind beunruhigt. Auf dem Konto einer Panama-Firma bei Ihrer
              Bank kommen laufend grosse Zahlungen rein, insgesamt acht Millionen Dollar.
              Das Geld stammt von einer anonymen Briefkastenfirma auf den Britischen
              Jungferninseln, von der Sie noch nie zuvor gehört haben. Bezahlt wird
              wieder über die litauische Ukio-Bank.'
              textTwoTitle='Die Begründung der Zahlungen'
              textTwo='Ihr Kunde legt Ihnen Verträge für den Verkauf von Baumaterialien
              vor. Neben den Verträgen verfügen Sie zusätzlich über Zollpapiere aus
              Litauen mit offiziellem Stempel für die Einfuhr sowie Frachtpapiere für
              den Transport der Materialien.'
              textThreeTitle='Das Problem'
              textThree='Ihr Kunde hat Ihnen die zusätzlichen Zoll- und Frachtpapiere
              erst nach mehrmaligem Nachhaken vorgelegt.'
              expertentext='Hier ist die Bank sorgfältig genug vorgegangen. Sie hat
              zusätzliche Unterlagen einverlangt, um den Geldfluss zu plausibilisieren,
              und das getan, was eine Bank mit vertretbarem Aufwand tun kann. So kann
              sie das Geld annehmen.'
              realCaseTitle='Was tatsächlich geschah'
              realCaseText='Dieser Fall ist erfunden und zeigt, wie eine Bank die Legitimität einer Zahlung überprüfen könnte.'
            />
          </div>

          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
          </div>

          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Fall 4</h2>
            <span className='pretext'>Ping-Pong-Spiel mit Schuldscheinen</span>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-4'
              articleId='19613986'
              solution='nein'
              imageTitle='dickinson_1'
              titleDocument='Originalbelege'
              descriptionDocument='(Klicken zum Vergrössern)'
              filenameDocument='dickinson_1.png'
              documentIsWide={true}
              question='Nehmen Sie das Geld an?'
              textOneTitle='Woher kommt das Geld?'
              textOne='Zwei Briefkastenfirmen von den Britischen Jungferninseln überweisen
              sich gegenseitig immer wieder Geld. Die eine hat ein Konto bei Ihrer Bank,
              die andere bei der litauischen Ukio-Bank. In knapp 200 Transfers fliessen
              36 Millionen Dollar in die eine und 56 Millionen Dollar in die andere Richtung.'
              textTwoTitle='Die Begründung der Zahlungen'
              textTwo='Die Zahlungen werden in beide Richtungen mit identisch abgefassten
              Schuldscheinen begründet, die sich die zwei Firmen gegenseitig verkaufen.
              Für die Firma mit Konto bei Ihrer Bank unterzeichnet nicht der Inhaber der
              Firma, sondern eine Person mit Generalvollmacht.'
              expertentext='Die Transaktionen sind auf jeden Fall abzulehnen: Neben
              bereits erwähnten Anhaltspunkte zu Geldwäscherei kommen hier noch weitere
              verdachtsbegründende Faktoren dazu: Die Höhe und Häufigkeit der Transaktionen,
              die Hin- und Her-Transaktionen («in and out») und das Vorliegen einer
              Einzel- und Blankovollmacht.'
              realCaseTitle='Was tatsächlich geschah'
              realCaseText='Die Transaktionen fanden wie beschrieben zwischen Februar 2008 und April 2012 statt. Erlaubt hat sie die UBS auf einem ihrer Schweizer Konten.'
            />
          </div>

          <p className='spaced'>&nbsp;</p>
          <div className='ui text container'>
            <h5 className='continueTitle'>Die Fortsetzung des Falls:</h5>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-5'
              articleId='19613986'
              solution='nein'
              imageTitle='dickinson_2'
              titleDocument='Original Belege'
              descriptionDocument='(Klicken zum vergrössern)'
              filenameDocument='dickinson_2.png'
              question='Nehmen Sie das Geld an?'
              textOneTitle='Woher kommt das Geld?'
              textOne='Auf dem Konto derselben Briefkastenfirma bei Ihrer Bank
              treffen zusätzlich noch 1,5 Millionen Dollar einer Belize-Briefkastenfirma ein. '
              textTwoTitle='Die Begründung der Zahlungen'
              textTwo='Die Firma legt einen Vertrag für «Legal Services» vor, also für
              juristische Dienstleistungen. Der zweiseitige Vertrag legt den maximalen
              Wert der Dienstleistungen bei just den 1,5 Millionen Dollar fest.'
              textThreeTitle='Das Problem'
              textThree='Laut Vertrag sollen die Dienstleistungen erst bezahlt werden,
              nachdem sie erbracht und in Rechnung gestellt worden sind. Die 1,5-Millionen-Dollar
              treffen aber schon 12 Tage nach Abschluss des Vertrages bei Ihrer Bank ein.'
              expertentext='Solche fiktiven Dienstleistungsverträge werden häufig eingesetzt,
              um die Bank in die Irre zu führen. Auch hier stellt sich die Frage, ob solche
              Geschäfte üblicherweise in dieser Art vertraglich geregelt werden. Gerade bei
              juristischen Dienstleistungen sollte man annehmen, dass die Verträge ordentlich
              ausgestaltet sind. Es ist unrealistisch, dass der Preis der Dienstleistung
              bereits feststeht, bevor klar ist, welche Dienstleistung erfolgt und in welchem
              Umfang! Dazu kommt noch das erhöhte Länderrisiko (Litauen, Belize und BVI).
              Ich würde die Transaktionen auf keinen Fall durchführen.'
              realCaseTitle='Was tatsächlich geschah'
              realCaseText='Diese Überweisung traf am 11. April 2012 auf dem UBS-Konto ein.
              Es ist die jüngste Überweisung auf dieses Konto, die sich im Datenleck finden
              lässt. Möglicherweise wurde das Konto danach also doch noch aufgelöst.'
            />
          </div>

          <p className='spaced'>&nbsp;</p>

          {/*
          <div className='ui container question-header'>
            <div className='question-headerIcons'>
              <img src={require('./imgs/money_blue_2.svg')} alt='' className='icon step' />
              <img src={require('./imgs/money_blue_2.svg')} alt='' className='icon step' />
              <img src={require('./imgs/money_blue_2.svg')} alt='' className='icon step' />
              <img src={require('./imgs/money_grey_2.svg')} alt='' className='icon step' />
            </div>

            <div className='question-headerContent'>
              <h2 className='story-step'>Fall 4</h2>
              <p className='pretext'>Modems</p>
            </div>
          </div>


          */}
        </main>

        {/* Experte */}

        <div className='ui vertical fitted attached segment' id='methodik'>
          <div
            className='ui text container methodik'
            style={{ position: 'relative' }}
          >
            <div className='WrapperExperte'>
              <img
                src={require('../quiz/imgs/daniel_thelesklaf.jpg')}
                className='ui circular fluid image'
                style={{ maxWidth: '45px', minWidth: '45px' }}
              />
              <h3>Der Experte</h3>
            </div>

            <p style={{ marginTop: '0.35em' }}>
              Daniel Thelesklaf beschäftigt sich seit über 20 Jahren mit
              Geldwäscherei und deren Bekämpfung. Die Einschätzung der Fälle
              machte er in seiner Funktion als Präsident von Moneyval, einem
              Geldwäscherei-Expertenkomitee des Europarats. Thelesklaf ist
              aktuell Leiter der Geldwäscherei-Behörde FIU in Liechtenstein. Ab
              August 2019 übernimmt er die Leitung der Schweizer
              Geldwäscherei-Meldestelle MROS.
            </p>
            <a href='https://www.tagesanzeiger.ch/29514609' target='_blank'>
              <i className='icon external alternate' />
              Lesen Sie hier, wie Daniel Thelesklaf die Erkenntnisse aus dem
              Troika-Laundromat beurteilt.
            </a>
            <p></p>

            <h3>Die Pflichten der Banken</h3>
            <p>
              Schweizer Banken müssen bei auffälligen Transaktionen genau
              hinschauen, um das Geldwäsche-Risiko zu mindern. Das
              Geldwäschereigesetz verpflichtet die Banken unter anderem, dann
              «die wirtschaftlichen Hintergründe und den Zweck einer
              Transaktion» abzuklären, wenn die Transaktion «ungewöhnlich
              erscheint» oder «mit einem erhöhten Risiko behaftet» ist. Auf
              Verordnungsebene sind Beispiele ausgeführt, die auf erhöhte
              Risiken hindeuten können, etwa wenn bei einer Transaktion
              Briefkastenfirmen involviert sind, insbesondere aus dem Ausland,
              oder wenn Transaktionen durch ihre Höhe auffallen.
            </p>
            <p>
              Bei Transaktionen mit erhöhten Risiken muss eine Bank «mit
              angemessenem Aufwand zusätzliche Abklärungen» treffen. Dazu gehört
              unter anderem, «die Plausibilität grösserer Zahlungseingänge» zu
              prüfen.
            </p>
            <p>
              Ähnlich formulierte Sorgfaltspflichten galten schon 2009 bis 2012.
              Das ist die Zeitspanne, aus der die Beispiele des Spiels stammen.
            </p>
            <p>
              Wenn die Banken Verdacht schöpfen, dass mit einer Überweisung Geld
              gewaschen worden sein könnte, dann sind sie verpflichtet, dies der
              Geldwäscherei-Meldestelle MROS zu melden. Ob in hier dargestellten
              Fällen Meldung erstattet wurde, ist nicht bekannt.
            </p>

            <h3>Das sagen die Banken</h3>
            <h3>UBS</h3>
            <p>
              Aus gesetzlichen und regulatorischen Gründen können wir zu
              einzelnen Personen oder zur Frage, ob diese Kunde waren oder sind,
              keine Stellung nehmen. UBS befolgt alle Gesetze überall, wo die
              Bank tätig ist. Wir dulden keinen Missbrauch jeglicher Art und
              gehen Verdachtsmomenten systematisch nach.
            </p>
            <p>
              Bei der Ermittlung verdächtiger Transaktionen verwendet UBS ein
              hoch entwickeltes System von IT-basierten Überwachungstools und
              führt für ihre Mitarbeiter regelmässig Schulungen durch zu allen
              wesentlichen Aspekten der Geldwäschereibekämpfung.
            </p>
            <p>
              Regelmässig melden wir den für die Geldwäschereibekämpfung
              zuständigen Behörden verdächtige Aktivitäten.
            </p>
            <h3>VP Bank</h3>
            <p>
              Über mögliche Kundenbeziehungen machen wir keine Angaben. Wir
              möchten aber Folgendes festhalten:
            </p>
            <p>
              Die VP Bank (Schweiz) AG untersteht dem Schweizerischen
              Geldwäschereigesetz sowie der Eidgenössischen Finanzmarktaufsicht
              (Finma) und hält die regulatorischen Vorgaben selbstverständlich
              jederzeit ein. Die unabhängige Compliance-Abteilung prüft
              risikobasiert die Einhaltung der regulatorischen Vorgaben. Bei
              Vorliegen von Anhaltspunkten für Geldwäscherei prüft sie diese und
              meldet Verdachtsfälle proaktiv; sei es im Rahmen der Meldepflicht
              oder des Melderechts. Zur Prävention von Geldwäscherei, Vortaten
              zur Geldwäscherei, organisierter Kriminalität und
              Terrorismusfinanzierung identifiziert die VP Bank (Schweiz) AG
              über ein softwareunterstütztes Monitoring-System ungewöhnliche
              Sachverhalte und Transaktionen.
            </p>
          </div>
        </div>

        <Footer
          credits={[
            [
              'Text, Recherche und Idee',
              'Christian Brönnimann und Oliver Zihlmann'
            ],
            ['Programmierung und Gestaltung', 'Patrick Vögeli']
          ]}
          questions={[
            'Wie informativ war der Beitrag?',
            'Eignet sich das Format Quiz für dieses Thema?',
            'Funktionierte die technische Umsetzung?'
          ]}
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
          starColor='blue'
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
